__turbopack_context__.v({
  "actions": "bE_z0q_actions",
  "body": "bE_z0q_body",
  "closeButton": "bE_z0q_closeButton",
  "container": "bE_z0q_container",
  "description": "bE_z0q_description",
  "header": "bE_z0q_header",
  "separator": "bE_z0q_separator",
  "title": "bE_z0q_title",
});
